import InaccuracyReportDialog from './InaccuracyReportDialog';

export default InaccuracyReportDialog;



// WEBPACK FOOTER //
// ./src/components/Building/InaccuracyReportDialog/index.js